/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExternalWeb = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12 2c5.523 0 10 4.477 10 10 0 .762-.086 1.506-.248 2.222l-1.95-.444A8.031 8.031 0 0 0 19.748 10h-1.956a14.67 14.67 0 0 1 .065 4.129l-1.983-.258c.172-1.324.11-2.641-.108-3.871H13v4h2v2h-2v6h-1C6.477 22 2 17.523 2 12c0-5.02 3.7-9.175 8.52-9.89l.005-.003v.002C11.007 2.04 11.5 2 12 2zM8.594 16a10.676 10.676 0 0 0 2.386 3.933l.02.003V16zm-3.52 0a8.037 8.037 0 0 0 2.524 2.679A12.532 12.532 0 0 1 6.5 16zm-.822-6A8 8 0 0 0 4 12a8 8 0 0 0 .252 2h1.852a14.722 14.722 0 0 1 .079-4zm3.92.222A12.643 12.643 0 0 0 8.119 14H11v-4H8.213c-.013.074-.03.147-.041.222zM7.754 5.22A8.037 8.037 0 0 0 5.074 8h1.555c.298-1.02.686-1.96 1.125-2.78zM11 4.187c-.42.356-.917.957-1.396 1.813a12.14 12.14 0 0 0-.878 2H11zM13 8h2.251a13.083 13.083 0 0 0-.24-.65c-.37-.924-.811-1.713-1.261-2.317a5.186 5.186 0 0 0-.75-.825zm3.21-2.802c.237.44.459.912.658 1.41.177.441.337.907.479 1.392h1.58a8.037 8.037 0 0 0-2.716-2.802z" />
        <path d="M22 22h-2v-2.175a9.706 9.706 0 0 1-1.317.966C17.459 21.539 16.099 22 15 22v-2c.615 0 1.613-.289 2.64-.916A7.55 7.55 0 0 0 19.026 18H17v-2h5z" />
      </g>
    </g>
  </Icon>
);
export { SvgExternalWeb as ExternalWeb };
